/* eslint-disable react-hooks/exhaustive-deps */
import { isArray } from "lodash-es";
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";

const Select = (props) => {
  const {
    name,
    placeholder,
    onChange: _onChange,
    list,
    value: _value,
    // defaultValue,
    children,
    className,
    disabled,
    mode,
    data,
  } = props;

  // const [_defaultValue, _setDefaultValue] = useState("");

  // useEffect(() => {
  //   _setDefaultValue(defaultValue);
  // }, [defaultValue]);
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(_value || undefined);
  }, [_value]);

  const onChange = (e, data) => {
    _onChange(e, data);
    setValue(e.target.value);
  };

  return (
    <div className="select-wrap">
      <select
        name={name}
        className={classnames("component-select",
          disabled ? "disabled" : "",
          className
        )}
        placeholder={placeholder}
        onChange={(e) => onChange(e, data)}
        // defaultValue={_defaultValue}
        value={value}
        disabled={disabled || mode === 'view'}
      >
        {children
          ? children
          : isArray(list) &&
          list.map(({ value, label }, idx) => (
            <option key={idx} value={value}>
              {label}
            </option>
          ))}
      </select>
    </div>
  );
};
export default Select;
